<template>
    <Progressbar v-if="loading" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="w-full h-full bg-gray-200 dark:bg-base-100 rounded-tr-3xl xl:px-9 pt-10 pb-14 " v-else>
        <div class="container">
            <div class="flex justify-between items-center mb-6">
                <h3 class="flex items-center md:text-26 text-xl dark:text-white text-biscay-700 font-semibold">
                    <i class="md:flex hidden w-2 h-2 dark:bg-white rounded-full bg-blue-700 ml-2"></i>
                    {{ __('Sale route details') }}
                </h3>
                <div class="flex justify-end order-first lg:order-last">
                    <Dropdown labelClass="btn-outline !btn-sm">
                        <ul class="menu dropdown-content bg-base-100 rounded-box z-[2] w-36 p-2 shadow lg:!end-auto">
                            <li>
                                <router-link :to="{ name: 'user.sale.route.edit', params: { id: saleRoute.id } }"
                                    :disabled="!can('setting.edit')">
                                    {{ __('Edit') }}
                                </router-link>
                            </li>
                            <li> <label for="move-modal">
                                    {{ __('Move') }}
                                </label></li>
                        </ul>
                    </Dropdown>
                    <label @click="setItem(saleRoute)" for="delete-modal"
                        :class="{ 'btn-disabled': !can('setting.delete') }"
                        class="btn btn-outline btn-error btn-sm mr-2">
                        {{ __('Delete') }}
                    </label>
                </div>
            </div>
            <div
                class="bg-white dark:bg-base-300 dark:shadow-whiteShadow rounded-xl shadow-sm sm:px-6 sm:py-6 px-3 py-4  my-5">

                <div class="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-3 md:gap-x-14 gap-y-4">
                    <p class="text-gray-70">{{ __('Title') }}: <span class="text-black dark:text-white">{{
                        saleRoute.title }}</span></p>
                    <p class="text-gray-70">{{ __('User') }}: <span class="text-black dark:text-white">{{ saleRoute.user
                    }}</span></p>
                    <p class="text-gray-70">{{ __('Created At') }}: <span class="text-black dark:text-white">{{
                        saleRoute.created_at }}</span></p>
                    <p class="text-gray-70">{{ __('Update date') }}: <span class="text-black dark:text-white">{{
                        saleRoute.updated_at }}</span></p>
                    <div class="divider h-auto col-span-full my-0"></div>
                    <p class="text-gray-70 font-bold">{{ __('Routes') }}</p>
                    <ul class="timeline w-full justify-center col-span-full">
                        <li v-for="item in saleRoute.items">
                            <hr class="bg-neutral" />
                            <div class="timeline-middle">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor"
                                    class="h-5 w-5 fill-success">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="timeline-end min-w-28 text-center">{{ item.title }}</div>
                            <hr class="bg-neutral" />
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <Teleport to="#app">
        <input type="checkbox" id="move-modal" class="modal-toggle" />
        <div class="modal">
            <Form class="modal-box bg-base-300" @submit="moveSaleProcess" v-slot="{ errors }">
                <h3 class="font-bold text-lg">{{ __('Move opportunity') }}</h3>
                <div class="flex flex-col mt-4">
                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                        {{ __('Move from') }}
                    </label>
                    <Field as="select" v-model="remove.process_id" :class="{ 'select-error': errors.process_id }"
                        class="select" name="process_id" rules="required">
                        <option value="">{{ __('Select...') }}</option>
                        <option v-for="item in saleRoute.items.filter(item => item.id != remove.move_to)"
                            :value="item.id">{{ item.title }}</option>
                    </Field>
                </div>
                <div class="flex flex-col mt-4">
                    <label class="text-dark-550 dark:text-gray-810 text-sm mb-1 font-medium" for="">
                        {{ __('Move to') }}
                    </label>
                    <Field as="select" v-model="remove.move_to" :class="{ 'select-error': errors.move_to }"
                        class="select" name="move_to" rules="required">
                        <option value="">{{ __('Select...') }}</option>
                        <option v-for="item in saleRoute.items.filter(item => item.id != remove.process_id)"
                            :value="item.id">{{ item.title }}</option>
                    </Field>
                </div>
                <div class="modal-action">
                    <label class="btn btn-sm" for="move-modal"
                        :class="{ 'pointer-events-none opacity-60': loadingBtn }">{{
                            __('Cancel') }}</label>
                    <button type="submit" class="btn btn-success btn-sm text-white" :class="{ 'loading': loadingBtn }">
                        {{ __('Move') }}
                    </button>
                </div>
            </Form>
        </div>
    </Teleport>
    <Teleport to="#app">
        <input type="checkbox" id="delete-modal" class="modal-toggle" />
        <label class="modal" for="delete-modal">
            <label class="modal-box" for="">
                <h3 class="font-bold text-lg">{{ __('Delete sale route') }}</h3>
                <p class="py-4">{{ __('Are you sure to delete this sale route?') }}</p>
                <div class="modal-action">
                    <label class="btn btn-sm" for="delete-modal"
                        :class="{ 'pointer-events-none opacity-60': loadingBtn }">{{
                            __('Cancel') }}</label>
                    <button class="btn btn-error btn-sm text-white" @click="removeSaleRoute"
                        :class="{ 'loading': loadingBtn }">
                        {{ __('Delete') }}
                    </button>
                </div>
            </label>
        </label>
    </Teleport>
</template>
<script setup>

import { computed, onMounted, onUpdated, reactive, ref } from 'vue';
import { Field, Form } from "vee-validate";
const { getSaleRoute, saleRoute, loading, remove, meta, errors, router, moveSaleProcess, removeSaleRoute, loadingBtn } = useDashboard();
const setPage = (p) => {
    setQuery('page', p.toString());
};
const setItem = (item, self = true) => Object.assign(remove, { id: item.id, single: self });
const getData = () => {
    getSaleRoute();
}
onMounted(() => {
    getData();
});
</script>